var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserSquare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6282 19.8192C15.8216 20.0575 14.8682 20.1675 13.7499 20.1675H8.24991C7.13158 20.1675 6.17825 20.0575 5.37158 19.8192C5.57325 17.4358 8.02075 15.5566 10.9999 15.5566C13.9791 15.5566 16.4266 17.4358 16.6282 19.8192Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7499 1.83398H8.24992C3.66659 1.83398 1.83325 3.66732 1.83325 8.25065V13.7507C1.83325 17.2157 2.87825 19.1131 5.37159 19.819C5.57325 17.4356 8.02075 15.5565 10.9999 15.5565C13.9791 15.5565 16.4266 17.4356 16.6283 19.819C19.1216 19.1131 20.1666 17.2157 20.1666 13.7507V8.25065C20.1666 3.66732 18.3333 1.83398 13.7499 1.83398ZM10.9999 12.9898C9.18492 12.9898 7.71825 11.514 7.71825 9.699C7.71825 7.884 9.18492 6.41732 10.9999 6.41732C12.8149 6.41732 14.2816 7.884 14.2816 9.699C14.2816 11.514 12.8149 12.9898 10.9999 12.9898Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2816 9.6977C14.2816 11.5127 12.8149 12.9885 10.9999 12.9885C9.18493 12.9885 7.71826 11.5127 7.71826 9.6977C7.71826 7.8827 9.18493 6.41602 10.9999 6.41602C12.8149 6.41602 14.2816 7.8827 14.2816 9.6977Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSquare);
export default __webpack_public_path__ + "static/media/user-square.c0b17c1bd75c4018c0e39db1ef89ed69.svg";
export { ForwardRef as ReactComponent };